<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" class="icon">
    <g>
      <path
        d="M14.977,2.72l1,13.28h3.149c0.328,0,0.574,0.16,0.82,0.48c0.082,0.32,0.082,0.64-0.082,0.88 c-2.296,3.28-6.144,6.4-6.308,6.48c-0.159,0.078-0.393,0.152-0.556,0.157c-0.005,0-0.012,0.003-0.017,0.003c0,0,0,0,0,0s0,0,0,0 c-0.164,0-0.41-0.08-0.492-0.16c-0.164-0.08-4.023-3.12-6.319-6.48c-0.164-0.32-0.246-0.64-0.082-0.88 C6.253,16.16,6.499,16,6.827,16h3.15l1-13.28C11.297,2.32,12.103,2,12.983,2C13.783,2,14.657,2.24,14.977,2.72z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "add-item-outline",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
